export default __webpack_public_path__ + "static/media/img-icon-Facebook.1359a6e0.svg";